module.exports = __webpack_public_path__ + "assets/img/a72e39ee90e2ed45f920b1b96d3b1c16.png";